import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const statusColor = comic.status === '连载中' ? 'bg-primary-500' : 'bg-secondary-500';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`${statusColor} text-background-50 text-xs px-2 py-0.5 rounded-full whitespace-nowrap`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <div className="flex items-center gap-1 text-accent-400 text-xs">
            <i className="ri-star-fill w-3 h-3 flex items-center justify-center"></i>
            <span>{comic.rating}</span>
            <span className="text-background-50/60 ml-1">{comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}阅读</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors duration-200">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-600 mt-1 truncate">{comic.author}</p>
        <div className="flex flex-wrap gap-1 mt-2">
          {comic.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-xs text-secondary-600 bg-secondary-100 px-1.5 py-0.5 rounded whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}